var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import AntTable from "antd/es/table";
const renderContent = (value, row, index) => {
    const obj = {
        children: value,
        props: {},
    };
    if (row.colSpan && value) {
        obj.props.colSpan = row.colSpan;
    }
    if (row.colSpan && typeof value === "undefined") {
        obj.props.colSpan = 0;
    }
    return obj;
};
const Table = (_a) => {
    var { className, columns, dataSource, loading, pagination, title, rowClassName, onRow } = _a, props = __rest(_a, ["className", "columns", "dataSource", "loading", "pagination", "title", "rowClassName", "onRow"]);
    return (React.createElement(AntTable, Object.assign({ bordered: true, className: classNames("gerudo-table", className, {
            "row-clickable": Boolean(onRow),
        }), columns: columns.map((col) => {
            return Object.assign({ render: renderContent }, col);
        }), dataSource: dataSource, loading: loading, pagination: pagination, rowClassName: (row) => row.className, rowKey: (row) => row.key, title: title, onRow: onRow }, props)));
};
const columnsShape = PropTypes.arrayOf(PropTypes.shape({
    align: PropTypes.oneOf(["left", "right", "center"]),
    className: PropTypes.string,
    colSpan: PropTypes.number,
    dataIndex: PropTypes.string.isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}));
const dataSourceShape = PropTypes.oneOfType([
    PropTypes.shape({
        key: PropTypes.string.isRequired,
    }),
    PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
    })),
]);
Table.defaultProps = {
    className: "",
    columns: [],
    dataSource: [],
    loading: false,
    pagination: false,
    rowClassName: "",
};
Table.propTypes = {
    className: PropTypes.string,
    columns: columnsShape,
    dataSource: dataSourceShape,
    loading: PropTypes.bool,
    pagination: PropTypes.bool,
    rowClassName: PropTypes.string,
    onRow: PropTypes.func,
};
export default Table;
export { Table };
//# sourceMappingURL=index.js.map